import { useRef, useState } from 'react'

export const createManualFormState = () => ({
  itemId: '',
  warehouseId: '',
  movementType: 'IN_MANUAL',
  quantity: '',
  qtyUnit: '',
  note: ''
})

export const createTransferFormState = () => ({
  itemId: '',
  fromWarehouseId: '',
  toWarehouseId: '',
  quantity: '',
  qtyUnit: '',
  note: ''
})

export const createRecipeFormState = () => ({
  version: '1',
  yieldQty: '1',
  active: true
})

export const createRecipeComponentsState = () => [
  { componentItemId: '', qtyRequired: '', displayQuantity: '', displayUnit: '', wastePct: '', sortOrder: '1' }
]

export const createWarehouseFormState = () => ({
  name: '',
  isDefault: false,
  isActive: true
})

export const createItemFormState = () => ({
  sku: '',
  name: '',
  unit: 'UN',
  itemType: 'PRODUCT',
  controlsInventory: true,
  usesRecipe: false,
  price: '',
  active: true
})

export const createEditableItemFormState = () => ({
  itemId: '',
  sku: '',
  name: '',
  unit: 'UN',
  itemType: 'PRODUCT',
  controlsInventory: true,
  usesRecipe: false,
  price: '',
  active: true
})

const useInventoryPageState = () => {
  const [warehouseSearch, setWarehouseSearch] = useState('')
  const [itemSearch, setItemSearch] = useState('')
  const [itemTypeFilter, setItemTypeFilter] = useState('')
  const [stockSearch, setStockSearch] = useState('')
  const [movementSearch, setMovementSearch] = useState('')
  const [movementType, setMovementType] = useState('')
  const [manualForm, setManualForm] = useState(createManualFormState)
  const [transferForm, setTransferForm] = useState(createTransferFormState)
  const [selectedBomItemId, setSelectedBomItemId] = useState('')
  const [recipeForm, setRecipeForm] = useState(createRecipeFormState)
  const [recipeComponents, setRecipeComponents] = useState(createRecipeComponentsState)
  const [warehouseForm, setWarehouseForm] = useState(createWarehouseFormState)
  const [isCreateWarehouseModalOpen, setIsCreateWarehouseModalOpen] = useState(false)
  const [itemForm, setItemForm] = useState(createItemFormState)
  const [isCreateItemModalOpen, setIsCreateItemModalOpen] = useState(false)
  const [itemEditForm, setItemEditForm] = useState(createEditableItemFormState)
  const [isEditItemModalOpen, setIsEditItemModalOpen] = useState(false)
  const [itemToDelete, setItemToDelete] = useState(null)
  const [itemsFile, setItemsFile] = useState(null)
  const [initialStockFile, setInitialStockFile] = useState(null)
  const [initialStockWarehouseId, setInitialStockWarehouseId] = useState('')
  const [itemsUploadResult, setItemsUploadResult] = useState(null)
  const [initialStockUploadResult, setInitialStockUploadResult] = useState(null)
  const [uploadHistory, setUploadHistory] = useState([])
  const [warehouseToDelete, setWarehouseToDelete] = useState(null)
  const initialWarehouseBootstrapRef = useRef({})
  const itemsFileRef = useRef(null)
  const initialStockFileRef = useRef(null)

  return {
    warehouseSearch,
    setWarehouseSearch,
    itemSearch,
    setItemSearch,
    itemTypeFilter,
    setItemTypeFilter,
    stockSearch,
    setStockSearch,
    movementSearch,
    setMovementSearch,
    movementType,
    setMovementType,
    manualForm,
    setManualForm,
    transferForm,
    setTransferForm,
    selectedBomItemId,
    setSelectedBomItemId,
    recipeForm,
    setRecipeForm,
    recipeComponents,
    setRecipeComponents,
    warehouseForm,
    setWarehouseForm,
    isCreateWarehouseModalOpen,
    setIsCreateWarehouseModalOpen,
    itemForm,
    setItemForm,
    isCreateItemModalOpen,
    setIsCreateItemModalOpen,
    itemEditForm,
    setItemEditForm,
    isEditItemModalOpen,
    setIsEditItemModalOpen,
    itemToDelete,
    setItemToDelete,
    itemsFile,
    setItemsFile,
    initialStockFile,
    setInitialStockFile,
    initialStockWarehouseId,
    setInitialStockWarehouseId,
    itemsUploadResult,
    setItemsUploadResult,
    initialStockUploadResult,
    setInitialStockUploadResult,
    uploadHistory,
    setUploadHistory,
    warehouseToDelete,
    setWarehouseToDelete,
    initialWarehouseBootstrapRef,
    itemsFileRef,
    initialStockFileRef
  }
}

export default useInventoryPageState
